var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 33,
    viewBox: "0 0 150 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_17341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2148 27.7721V19.145H74.3164V27.7721H80.393V5.10742H74.3148V13.7346H66.2148V5.10742H60.1367V27.7721H66.2148ZM100.313 27.7721V22.3586H89.0727V19.145H98.6258V13.7346H89.0727V10.5194H100.315V5.10742H82.9961V27.7721H100.313ZM108.862 27.7721V19.6526H109.335C111.191 19.6526 112.035 20.2277 112.946 21.7159L116.693 27.7721H123.615L120.374 22.665C119.227 20.8704 118.213 19.4169 115.885 18.8417C119.732 18.5023 122.67 16.5741 122.67 12.2103C122.67 7.20528 118.888 5.10742 113.623 5.10742H102.787V27.7721H108.862ZM113.69 10.5194C115.412 10.5194 116.255 11.2297 116.255 12.6503C116.255 14.0379 115.412 14.7827 113.69 14.7827H108.862V10.5194H113.69ZM142.224 27.7721V22.3586H130.985V19.145H140.537V13.7346H130.985V10.5194H142.226V5.10742H124.907V27.7721H142.224ZM149.988 27.769V21.9861H143.912V27.769H149.988Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.981 27.7672V21.9844H143.904V27.7672H149.981Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3883 28.2596L19.4461 28.2895L19.5117 28.2848L47.007 26.6128L44.5617 31.0332L16.818 32.7209L0.339844 24.5243L2.82891 20.0222L19.3883 28.2596ZM24.5164 9.31134L23.6273 5.0842L26.0023 0.646484L29.218 11.4406L24.5164 9.31134ZM20.5164 18.4319L9.96016 19.1626L1.85547 15.1901L4.36172 10.6612L21 18.4319H20.5164Z",
    fill: "#0B0B17",
    stroke: "#AAAAB6",
    strokeWidth: 0.466065
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4434 26.3371L19.5059 28.0374L2.5918 19.6774L20.9074 18.5649L4.25586 10.3353L12.434 3.39743L29.3934 11.7543L26.0684 0L42.2746 7.964L47.4434 26.3371Z",
    fill: "#0B0B17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_17341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHere);
export default __webpack_public_path__ + "static/media/here.ac1fc2b86b64ed9eb2e4035fa8762265.svg";
export { ForwardRef as ReactComponent };